
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { EstadoModel, estadosList } from "@/models/commons/EstadoModel";
import { ContaBancariaModel } from "@/models/commons/ContaBancariaModel";
import { EnderecoModel } from '@/models/commons/EnderecoModel';
import {
  tiposTelefoneList,
  ITelefoneModel,
} from "@/models/commons/TelefoneModel";
import { PrestadorModel } from "@/models/cadastros/assistencia/PrestadorModel";
import { IServicoPrestadorModel } from "@/models/cadastros/assistencia/ServicoPrestadorModel";
import { tiposEnderecoList } from "@/models/commons/EnderecoModel";
import { CONTA_CORRENTE } from "@/models/commons/TipoContaBancariaModel";
import { tipoServicoVeicularList } from "@/models/commons/TipoServicoModel";
import {
  tiposBancoList,
  TipoBancoModel,
} from "@/models/commons/TipoBancoModel";
import {
  tiposVeliculoList,
  TipoVeiculoModel,
} from "@/models/commons/TipoVeiculoModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { servicosSaudeEspecialidadeApi } from "@/api/ServicosSaudeEspecialidadeApi";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { mapasService } from "@/service/MapasService";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import CidadeModel from "@/models/cadastros/saude/CidadeModel";
import { BairroModel } from "@/models/cadastros/saude/BairroModel";
import { servicosSaudeCidadesApi } from "@/api/ServicosSaudeCidadesApi";
import { servicosSaudeBairrosApi } from "@/api/ServicosSaudeBairro";
import BankAccountValidator from "@/validators/br-bank-account-validator/dist";
import { BancoDTO } from "@/models/commons/BancoModel";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog
  },
})
export default class CadastroPrestador extends Vue {
  $refs!: {
    telefoneObserver: InstanceType<typeof ValidationObserver>;
    servicosObserver: InstanceType<typeof ValidationObserver>;
    dadosBasicosObserver: InstanceType<typeof ValidationObserver>;
    contaBacariaObserver: InstanceType<typeof ValidationObserver>;
  };

  moneyMaskProperties = moneyMaskProperties;
  telefoneValido = false;

  tiposServicos = tipoServicoVeicularList;

  tiposVeiculos = tiposVeliculoList;

  loadingAddress = false;
  ehLeveUtilitario = false;
  ehPesadoExtraPesado = false;

  estados = estadosList;
  cidades: string[] = [];
  bairros: string[] = [];

  tiposTelefone = tiposTelefoneList;
  listaBancos: TipoBancoModel[] = [];
  tipoVeiculo = tiposVeliculoList;
  tiposEndereco = tiposEnderecoList;
  cabecalho = [
    { text: "Tipo", value: "tipo.descricao", width: "25%" },
    { text: "Telefone", value: "numero", width: "35%" },
    { text: "Ramal", value: "ramal", width: "25%" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  cabecalhoServico = [
    { text: "Estado", value: "estado.nome", width: "10%", sortable: false },
    { text: "Cidade", value: "cidade", width: "10%", sortable: false },
    { text: "Bairro", value: "bairro", width: "10%", sortable: false },
    {
      text: "Serviço",
      value: "tipoServico.descricao",
      width: "10%",
      sortable: false,
    },
    {
      text: "Tipo de veículo",
      value: "tipoVeiculo.descricao",
      width: "10%",
      sortable: false,
    },
    { text: "Raio Distância", value: "raioDistancia", width: "5%", sortable: false },
    { text: "Km saída", value: "kmSaida", width: "5%", sortable: false },
    {
      text: "Valor km excedido",
      value: "valorKmExcedido",
      width: "10%",
      sortable: false,
    },
    { text: "Valor saída", value: "valorSaida", width: "10%", sortable: false },
    { text: "Valor Patins", value: "valorPatins", width: "10%", sortable: false },
    { text: "Valor H. Parada", value: "valorHoraParado", width: "10%", sortable: false },
    { text: "Valor H. Trabalhada", value: "valorHoraTrabalhado", width: "10%", sortable: false },
    { text: "Ações", value: "actions", sortable: false,  width: "15%" },
  ];

  servicos = [] as IServicoPrestadorModel[];

  endereco: EnderecoModel = {
      cep: "",
      logradouro: "",
      numero: undefined,
      complemento: "",
      bairro: "",
      cidade: "",
      estado: undefined,
    };

  contaBancaria: ContaBancariaModel = {
    codigoBanco: "",
    numeroAgencia: "",
    digitoAgencia: "",
    numeroConta: "",
    digitoConta: "",
    contaPrincipal: false,
    cpfCnpjTitular: "",
    nomeTitular: "",
    prestadorTitular: false,
    tipoPessoa: "FISICA",
    tipoContaBancaria: CONTA_CORRENTE
  };

  prestador: PrestadorModel = {
    ativo: true,
    endereco: this.endereco,
    telefones: [],
    precosServico: [],
    flagCadastroCPOM: false,
    cpfCnpj: "",
    contaBancaria: this.contaBancaria
  };

  telefone: ITelefoneModel = {};
  precoServico: IServicoPrestadorModel = {
    bairro: ""
  };

  tipoPopup = "";
  dialogType = "success";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  telefoneIndex = 0;
  servicoPrestadorIndex = 0;
  loading = false;
  bloqueiaEdicao = false;
  bloqueiaEdicaoServico = false;
  confirmaInsert = false;
  bancos: BancoDTO[] = [];
  ehPatins = false;
  ehHoraTrabalhada = false;
  ehHoraParada = false;
  exibirValor = true;

  @Watch("prestador", { immediate: true, deep: true })
  observarContaBancaria() {
    if (this.prestador.contaBancaria?.nomeTitular) {
      this.prestador.contaBancaria.tipoPessoa =
        this.prestador.tipoPessoaString == "F" ? "FISICA" : "JURIDICA";
      this.prestador.contaBancaria.cpfCnpjTitular =
        this.prestador.cpfCnpj || "";
      this.prestador.contaBancaria.nomeTitular =
        this.prestador.nomeRazaoSocial || "";
    }
  }

  @Watch('prestador.endereco.cep')
  private consultCEP(val: string): void {
    if (val != undefined) {
      this.requestAddress(val);
    }
  }

  @Watch('precoServico.cep')
  private consultaCEPPrecoServico(val: string): void {
    this.buscaCepServicoPreco(val);
  }

 /* @Watch('precoServico.tipoVeiculo')
  private alterarTipoVeiculo(val: string): void {
    if (this.precoServico.tipoVeiculo != undefined && this.precoServico.tipoServico?.name == 'GUINCHO') {
      this.ehLeveUtilitario = (this.precoServico.tipoVeiculo?.name == 'LEVE' || this.precoServico.tipoVeiculo?.name == 'UTILITARIO');;
      this.ehPesadoExtraPesado = (this.precoServico.tipoVeiculo?.name == 'ULTRA_PESADO' || this.precoServico.tipoVeiculo?.name == 'PESADO');
      return;
    }
    
    this.ehLeveUtilitario = false;
    this.ehPesadoExtraPesado = false;
  }*/

  @Watch('precoServico.tipoServico')
  private alterartipoServico(): void {
    this.ehPatins = false;
    this.ehHoraTrabalhada = false;
    this.ehHoraParada = false;
    this.exibirValor = true;
    if ( this.precoServico.tipoServico?.name == 'PATINS') {
      this.ehPatins = true;
      this.exibirValor = false;
      return;
    }
    if ( this.precoServico.tipoServico?.name == 'HORA_TRABALHADA') {
      this.ehHoraTrabalhada = true;
      this.exibirValor = false;
      return;
    }
    if (this.precoServico.tipoServico?.name == 'HORA_PARADA') {
      this.ehHoraParada = true;
      this.exibirValor = false;
      return;
    } 
  }

  requestAddress(val: string): void {
    val = val.replace(/\D/g, "");
    if (val && val.length === 8) {
      this.loadingAddress = true;
      mapasService
        .obterEnderecoPorCep(val.replace(/\D/g, ""))
        .then((res) => {
          const address: EnderecoModel = this.prestador.endereco ?? {};

          if (res.logradouro) {
            address.logradouro = res.logradouro;
          }
          if (res.bairro) {
            address.bairro = res.bairro;
          }
          if (res.cidade) { 
            address.cidade = res.cidade;
          }

          if (res.estado) {
            address.estado = estadosList.find(
              (e) => e.sigla == (res.estado?.sigla || "")
            );
          } else {
            address.estado = undefined;
          }
          this.prestador.endereco = address;
          this.bloqueiaEdicao = true;
        })
        .finally(() => {
          this.loadingAddress = false;
        });
    } else {
      this.bloqueiaEdicao = false;
      if (val && val.length < 8) {
        this.limparEndereco();
      }
    }
  }

  buscaCepServicoPreco(val: string): void {
    val = val.replace(/\D/g, "");
    if (val && val.length === 8) {
      this.loadingAddress = true;

      mapasService
        .obterEnderecoPorCep(val.replace(/\D/g, ""))
          .then((res) => {
            if (res.bairro) {
              this.precoServico.bairro = res.bairro;
            }
            if (res.cidade) {
              this.precoServico.cidade = res.cidade;
            }
            if (res.estado) {
              this.precoServico.estado = estadosList.find(
                (e) => e.sigla == (res.estado?.sigla || "")
              );
            } else {
              this.precoServico.estado = undefined;
            }
          })
          .finally(() => {
             mapasService
              .obterGeoLocalizacao(val.replace(/\D/g, ""))
              .then((res) => {
                this.precoServico.latitude = res.geoPosicao?.latitude;
                this.precoServico.longitude = res.geoPosicao?.longitude;
              })
              .finally(() => {
                this.loadingAddress = false;
              });
          });


    } else {
      this.bloqueiaEdicaoServico = false;
      if (val && val.length < 8) {
        this.limparEnderecoServico();
      }
    }
  }

  limparEnderecoServico() {
    
    this.precoServico.bairro = "";
    this.precoServico.cidade = "";
    this.precoServico.estado = undefined;
    this.precoServico.latitude = undefined;
    this.precoServico.longitude = undefined;
  }

  limparEndereco() {
    
    let enderecoLimpo: EnderecoModel = {
      cep: "",
      logradouro: "",
      numero: undefined,
      complemento: "",
      bairro: "",
      cidade: "",
      estado: undefined,
    };

    this.prestador.endereco = enderecoLimpo;
  }

  loadInfo() {
    // limpar o cadastro antes de carregar as infos
    this.telefone = {};
    this.precoServico = {};
    this.prestador = {
      ativo: true,
      endereco: {},
      telefones: [],
      precosServico: [],        
      flagCadastroCPOM: false,
      cpfCnpj: "",
      contaBancaria: {
        codigoBanco: "",
        numeroAgencia: "",
        digitoAgencia: "",
        numeroConta: "",
        digitoConta: "",
        contaPrincipal: false,
        cpfCnpjTitular: "",
        nomeTitular: "",
        prestadorTitular: false,
        tipoPessoa: "FISICA",
        tipoContaBancaria: CONTA_CORRENTE
      }
    };

    // carregar as infos
    if (this.$route.params.idPrestador) {
      ServicosAssistenciaService.obterPrestador(
        this.$route.params.idPrestador
      ).then((res) => {
        const prestador = res.data;
        const tipoEndereco = this.tiposEndereco.filter((t) => {
          return t.nome == prestador.enderecos[0]?.tipo;
        })[0];
        this.prestador = {
          id: prestador.id,
          cpfCnpj: prestador.cpfCnpj,
          nomeRazaoSocial: prestador.nome,
          flagCadastroCPOM: prestador.flagPrestadorCadastradoCPOM,
          tipoPessoaString: prestador.tipoPessoa.substring(0, 1),
          email: prestador.email,
          ativo: prestador.ativo,
          endereco: {
            cep: prestador.enderecos[0].cep,
            tipo: tipoEndereco,
            logradouro: prestador.enderecos[0].logradouro,
            numero: prestador.enderecos[0].numero,
            complemento: prestador.enderecos[0].complemento,
            bairro: prestador.enderecos[0].bairro,
            cidade: prestador.enderecos[0].cidade,
            estado: this.estados.filter((e) => {
              return e.sigla == prestador.enderecos[0].estado;
            })[0],
          },
          telefones: prestador.telefones.map((t: any, index: number) => {
            const telefoneModel: ITelefoneModel = {
              idTelefone: index,
              numero: `(${t.ddd}) ${t.numero}`,
              ramal: t.ramal,
              tipo: this.tiposTelefone.filter((tipo) => {
                return tipo.nome == t.tipo;
              })[0],
            };
            return telefoneModel;
          }),

          precosServico: prestador.precosServico.map((s: any) => {
            const precoServico: IServicoPrestadorModel = {
              id: s.id,
              tipoServico: this.tiposServicos.find(
                (srv) => srv.name == s.tipoServico
              ),
              kmSaida: s.kmSaida,
              valorKmExcedido: s.valorKmExcedido,
              estado: estadosList.find((e) => e.sigla == s.estado),
              cidade: s.cidade,
              bairro: s.bairro,
              valorSaida: s.valorSaida,
              tipoVeiculo: this.tiposVeiculos.find((t: TipoVeiculoModel) => {
                return t.name == s.tipoVeiculo;
              }),
              cep: s.cep,
              raioDistancia: s.raioDistancia,
              latitude: s.latitude,
              longitude: s.longitude, 
              valorPatins: s.valorPatins ? s.valorPatins.toString() : "0",
              valorHoraParado: s.valorHoraParado ? s.valorHoraParado.toString() : "0",
              valorHoraTrabalhado: s.valorHoraTrabalhado ? s.valorHoraTrabalhado.toString() : "0"
            };
            return precoServico;
          }),
          contaBancaria: prestador.contaBancaria,
        };

        this.telefoneIndex = this.prestador.telefones?.length || 0;
        this.servicoPrestadorIndex = this.prestador.precosServico?.length || 0;
      });
    }
  }

  mounted() {
    this.loadInfo();
    this.obterBancos();
  }

  obterBancos() {
    this.loading = true;
    this.bancos = [];
    ServicosAssistenciaService
    .obterBancos().then((res: BancoDTO[]) => {
          this.bancos = res;
          this.loading = false;
          this.formatarBancos();
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  formatarBancos() {
    for (var val of this.bancos) {
      this.listaBancos.push({ value: val.id, descricao: val.id + " - " + val.descricao });
    }
  }

  //Computed properties
  get textoBotaoTelefone() {
    return this.telefone &&
      this.telefone?.idTelefone !== undefined &&
      this.telefone?.idTelefone >= 0
      ? "Salvar telefone"
      : "Adicionar telefone";
  }

  get textoBotaoServico() {
    return this.precoServico &&
      this.precoServico?.tipoServico?.name !== undefined
      ? "Salvar serviço"
      : "Adicionar serviço";
  }

  adicionarTelefone() {
    this.$refs.telefoneObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.prestador.telefones) {
          this.prestador.telefones = [this.telefone];
        }
        const partes = this.telefone.numero?.split(" ") as string[];
        if (partes.length == 3) {
          this.telefone.numero = `${partes[0]} ${partes[1]}${partes[2]}`;
        }

        const idx = this.prestador.telefones
          .map((t) => t.idTelefone)
          .indexOf(this.telefone.idTelefone);
        if (idx >= 0) {
          this.prestador.telefones.splice(idx, 1, this.telefone);
        } else {
          this.telefone.idTelefone = this.telefoneIndex++;
          this.prestador.telefones.push(this.telefone);
        }
        this.telefone = {};
        this.$refs.telefoneObserver.reset();
      }
    });
  }

  alterarTelefone(telefone: ITelefoneModel) {
    this.telefone = Object.assign({}, telefone);
  }

  removerTelefone(telefone: ITelefoneModel) {
    if (this.prestador.telefones) {
      const idx = this.prestador.telefones
        .map((t) => t.idTelefone)
        .indexOf(telefone.idTelefone);
      this.prestador.telefones.splice(idx, 1);
    }
  }

  cancelarTelefone() {
    this.telefone = {};
  }

  servicoIndex = -1;

  private verificarServicoAdicionado(
    servicos: IServicoPrestadorModel[],
    servicoAdicionar: IServicoPrestadorModel
  ) {
    return (
      servicos.findIndex((servico) =>
        this.verificarServicosIguais(servico, servicoAdicionar)
      ) > -1
    );
  }

  private verificarServicosIguais(
    servicoLista: IServicoPrestadorModel,
    servicoAdicionar: IServicoPrestadorModel
  ): boolean {
    const estadoIgual =
      servicoLista.estado?.sigla == servicoAdicionar.estado?.sigla;
    const cidadeIgual = servicoLista.cidade == servicoAdicionar.cidade;
    const bairroIgual = servicoLista.bairro == servicoAdicionar.bairro;
    const tipoServicoIgual =
      servicoLista.tipoServico?.name == servicoAdicionar.tipoServico?.name;
    const tipoVeiculoIgual =
      servicoLista.tipoVeiculo?.name == servicoAdicionar.tipoVeiculo?.name;

    return (
      estadoIgual &&
      cidadeIgual &&
      bairroIgual &&
      tipoServicoIgual &&
      tipoVeiculoIgual
    );
  }

  adicionarServico() {
    if (!this.prestador.precosServico) {
      this.prestador.precosServico = [];
    }
    if (this.servicoIndex >= 0) {
      this.prestador.precosServico.splice(this.servicoIndex, 1, this.precoServico);
      this.precoServico = {};
      this.$refs.servicosObserver.reset();
      this.servicoIndex = -1;
    } else {
      if (
        this.verificarServicoAdicionado(
          this.prestador.precosServico,
          this.precoServico
        )
      ) {
        this.openDialog('error', 'Serviço já adicionado ao prestador', 'O Serviço selecionado já foi adicionado ao prestador.');
      } else {

        this.prestador.precosServico.push(this.precoServico);
        this.precoServico = {};
        this.$refs.servicosObserver.reset();
        this.servicoIndex = -1;
      }
    }
  }

  alterarServico(servicoPrestador: IServicoPrestadorModel) {
    this.precoServico = Object.assign({}, servicoPrestador);
    this.servicoIndex = (this.prestador.precosServico || []).indexOf(
      servicoPrestador
    );
  }

  removerServico(servicoPrestador: IServicoPrestadorModel) {
    if (this.prestador.precosServico) {
      const idx = this.prestador.precosServico.indexOf(servicoPrestador);
      this.prestador.precosServico.splice(idx, 1);
    }
  }

  cancelarServico() {
    this.precoServico = {};
  }

  cancelar() {
    this.openDialog('confirm', 'Cancelar alterações', 'Deseja realmente cancelar o cadastro? Se confirmar, poderá perder os dados.', 'IGNORE');
  }

  voltarPagina() {
    this.$router.back();
  }

  gravar() {
    this.$refs.dadosBasicosObserver.validate().then((valid) => {
      if (valid) {
        if (
          !this.prestador.precosServico ||
          this.prestador.precosServico.length <= 0
        ) {
          this.openDialog('error', 'Nenhum serviço adicionado', 'Nenhum serviço foi adicionado para o prestador.');
          valid = false;
        }

        if (!this.prestador.telefones || this.prestador.telefones.length <= 0) {
          this.openDialog('error', 'Nenhum telefone adicionado', 'Nenhum telefone foi adicionado para o prestador.');
          valid = false;
        }

        if (this.prestador.contaBancaria) {
          try {

            let codigoBanco : string =  this.prestador.contaBancaria!.codigoBanco || '';
            let numeroAgencia : string =  this.prestador.contaBancaria!.numeroAgencia || '';
            let digitoAgencia : string =  this.prestador.contaBancaria!.digitoAgencia || '';
            let numeroConta : string =  this.prestador.contaBancaria!.numeroConta || '';
            let digitoConta : string = this.prestador.contaBancaria!.digitoConta || '';
            if (!this.confirmaInsert) {
              BankAccountValidator.validate({
                    bankNumber: codigoBanco,
                    agencyNumber: numeroAgencia,
                    agencyCheckNumber: digitoAgencia,
                    accountNumber: numeroConta,
                    accountCheckNumber: digitoConta
                });
            }

            this.confirmaInsert = false;
           
          } catch (e) {
              // se não for válida, lança uma exceção
              this.openDialog('confirm', 'Dados da Conta Inválidos', 'A conta bancária informada não passou pela validação, deseja continuar?', 'BANK');
              valid = false;
          }
        }
        if (valid) {
          if (this.prestador.id) {
            this.save();
          } else {
            ServicosAssistenciaService.verificarCpfCnpj(
              this.prestador.cpfCnpj || ""
            ).then((existe: any) => {
              if (!existe.data) {
                this.save();
              } else {
                  this.openDialog('error', 'Prestador já cadastrado', `Já existe um prestador cadastrado para o ${
                  this.prestador.tipoPessoaString == "F" ? "CPF" : "CNPJ"
                } informado.`);
              }
            });
          }
        }
      } else {
        setTimeout(() => {
          const errors = Object.entries(this.$refs.dadosBasicosObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.dadosBasicosObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    });
  }

  save() {
    this.loading = true;
    ServicosAssistenciaService.savePrestadorAssistencia(this.prestador).then(
      (res) => {
        if (this.prestador.id) {
          this.dialogTitle = "Alteração efetivada com sucesso";
          this.dialogMessage = "Prestador alterado com sucesso";
        } else {
          this.dialogTitle = "Cadastro efetivado com sucesso";
          this.dialogMessage = "Cadastro do prestador efetivado com sucesso";
        }
        this.openDialog('success', this.dialogTitle, this.dialogMessage);
        this.loading = false;
      },
      (err) => {
        this.openDialog('error', 'Erro ao gravar prestador', 'Ocorreu um erro ao tentar gravar os dados do prestador.');
        this.loading = false;
      }
    );
  }

  private openDialog(dialogType: string, title: string, message: string, type?: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;

    if (dialogType == 'confirm') {
      this.tipoPopup = type!!;
    }
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType === 'success') {
      this.$router.push({ name: "ListaPrestadores" });
    }
  }

  public confirm(){ 
    this.closeDialog();
    if (this.tipoPopup == 'BANK') {
      this.confirmaInsert = true;
      this.gravar();
    } else {
      this.loadInfo();
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
